import UnionIcon from './component'

export default UnionIcon
